import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type { ReactElement } from 'react'

interface Props {
  modelId: string
  tagId: number
  onSuccess: () => void
  children: () => ReactElement
}

const RevertAiModelRequest = ({
  modelId,
  tagId,
  onSuccess,
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/models/${modelId}/tags/${tagId}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='put'
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default RevertAiModelRequest
